<template>
    <v-container fluid>
        <Form v-if="hasAccess('TakeTeilnehmer.TakeSpecific')" v-slot="{ meta }">
            <h1>Einnehmen eines anderen Teilnehmerkontexts</h1>
            <span
                >Es kann entweder die TeilnehmerId oder die TvsKundennummer angegeben werden. Wird die TvsKundennummer angegeben, so wird der erste Teilnehmer
                mit dieser Nummer genommen.</span
            >
            <v-form @submit.prevent="takeSpecific(teilnehmer)">
                <v-row>
                    <v-col md="4" sm="6" lg="3">
                        <v-card>
                            <v-col class="py-0">
                                <Field v-slot="{ errors, field }" name="TeilnehmerId" rules="numeric">
                                    <v-text-field
                                        v-bind="field"
                                        v-model.number="teilnehmer.teilnehmerId"
                                        label="TeilnehmerId"
                                        placeholder="TeilnehmerId"
                                        :error-messages="errors"
                                        :disabled="teilnehmer.tvsKundennummer > 0 || teilnehmer.tvsLieferantennummer > 0"
                                    ></v-text-field>
                                </Field>
                                <Field v-slot="{ errors, field }" name="TvsKundennummer" rules="between:1000,9999|numeric">
                                    <v-text-field
                                        v-bind="field"
                                        v-model.number="teilnehmer.tvsKundennummer"
                                        label="TvsKundennummer"
                                        placeholder="TvsKundennummer"
                                        :error-messages="errors"
                                        :disabled="teilnehmer.teilnehmerId > 0 || teilnehmer.tvsLieferantennummer > 0"
                                    ></v-text-field>
                                </Field>
                                <Field v-slot="{ errors, field }" name="TvsLieferantennummer" rules="between:100,999|numeric">
                                    <v-text-field
                                        v-bind="field"
                                        v-model.number="teilnehmer.tvsLieferantennummer"
                                        label="TvsLieferantennummer"
                                        placeholder="TvsLieferantennummer"
                                        :error-messages="errors"
                                        :disabled="teilnehmer.teilnehmerId > 0 || teilnehmer.tvsKundennummer > 0"
                                    ></v-text-field>
                                </Field>

                                <Field v-slot="{ errors, field }" name="Rolle">
                                    <v-select
                                        v-bind="field"
                                        v-model="teilnehmer.benutzerRolle"
                                        :items="rolleItems"
                                        label="Rolle"
                                        :error-messages="errors"
                                    ></v-select>
                                </Field>
                            </v-col>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row class="pl-3">
                    <v-col sm="2 pt-0 pb-5">
                        <v-btn type="submit" :disabled="!meta.valid" large color="primary"> Set User </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </Form>
        <h3>Reset</h3>
        <v-row class="pl-3">
            <v-col sm="2 pb-5">
                <v-btn type="secondary" large color="secondary" @click="reset">Reset</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';
import { namespace } from 'vuex-facing-decorator';
import { TakeTeilnehmerApiDto } from '@/api-schema';

import { NAME as NAME_ADMINISTRATION } from '../store';
import { NAME as NAME_SECURITY } from '@/store/modules/security';
import { NAME as NAME_HEADERNOTIFICATION } from '@/store/modules/headerNotification';
import { NAME as NAME_GENERAL } from '@/store/modules/general';

const administrationModul = namespace(NAME_ADMINISTRATION);
const securityModul = namespace(NAME_SECURITY);
const headerModul = namespace(NAME_HEADERNOTIFICATION);
const generalModul = namespace(NAME_GENERAL);

import { SUBTITLE, FOOTERTITLE } from '@/store/modules/general/mutations';
import { TAKESPECIFIC, RESET } from '../store/actions';
import { HASACCESS } from '@/store/modules/security/getters';
import { SETACCESSDENIED } from '@/store/modules/security/mutations';
import { NEW_ALERT } from '@/store/modules/headerNotification/actions';

import { Form, Field } from 'vee-validate';

@Component({
    components: {
        Form,
        Field
    }
})
export default class TakeTeilnehmer extends Vue {
    teilnehmer: TakeTeilnehmerApiDto;
    rolleItems: Array<string>;

    @generalModul.Mutation(SUBTITLE) setSubTitle!: Function;
    @generalModul.Mutation(FOOTERTITLE) setFooterTitle!: Function;

    @administrationModul.Action(TAKESPECIFIC) takeSpecific!: Function;
    @administrationModul.Action(RESET) reset!: Function;

    @securityModul.Getter(HASACCESS) hasAccess!: Function;
    @securityModul.Mutation(SETACCESSDENIED) setAccessDenied!: Function;

    @headerModul.Action(NEW_ALERT) alertMessage!: Function;

    created() {
        this.setSubTitle('Teilnehmer-Wechsel');
        this.setFooterTitle('S900');
        if (!this.hasAccess('Navigation.TakeTeilnehmer')) {
            this.setAccessDenied(true);
            this.alertMessage({ text: 'Sie haben keinen Zugriff auf diese Site!' });
        } else {
            this.setAccessDenied(false);
        }
        this.teilnehmer = {
            teilnehmerId: null,
            tvsKundennummer: null,
            benutzerRolle: ''
        };
        this.teilnehmer.benutzerRolle = 'UserMain';

        this.rolleItems = [
            'UserMain',
            'UserStaff',
            'UserView',
            'UserUpload',
            'UserBuha',
            'LieferantMain',
            'LieferantUser',
            'PraxisgruppeMain',
            'PraxisgruppeUser',
            'TreuhandMain',
            'TreuhandUser'
        ];
    }
}
</script>

<style></style>
